import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { IEditorPlatformApplication_unsafe } from '../../types';
import { Addon, ApiConfig } from '../../limitPrivateAPI';

export class ApplicationManagerNamespace extends PrivateAPINamespace {
  static readonly namespace = 'applicationManager';

  @ApiConfig(Addon)
  public setApplication(app: IEditorPlatformApplication_unsafe) {
    this.ps.apps.setApplication(app);
  }

  @ApiConfig(Addon)
  public async getPublicApplicationAPI(appDefinitionId: string) {
    return this.ps.apps.getPublicAPIWhenAppIsReady(appDefinitionId);
  }
}
